<template>
  <div class="flex justify-content-center">
    <ProgressSpinner
      :style="{ width: size, height: size }"
      :strokeWidth="strokeWidth"
    />
  </div>
</template>

<script>
import ProgressSpinner from "primevue/progressspinner";
export default {
  name: "ProgressLoading",
  components: {
    ProgressSpinner
  },
  props: {
    size: {
      require: false,
      default: "35px"
    },
    strokeWidth: {
      require: false,
      default: "4"
    }
  }
};
</script>

<style>
@keyframes p-progress-spinner-color {
  100%,
  0% {
    stroke: var(--textinactive);
  }
  40% {
    stroke: var(--textinactive);
  }
  66% {
    stroke: var(--textinactive);
  }
  80%,
  90% {
    stroke: var(--textinactive);
  }
}
</style>
